export function usePdfTracker() {

    function downloadFile(fileUrl?: string) {
        if (!fileUrl) return

        const parts = fileUrl.split('/')
        const label = parts[parts.length - 1]

        if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
            window.gtag('event', 'pdf_download_ga4', {
                download_name: 'PDF Download GA4',
                download_label: label
            })
        }

        window.open(fileUrl, '_blank')
    }

    return { downloadFile }
}

